import * as React from 'react';
import { Button, Stack, AbsoluteBox, Box, Backdrop, Typography, Grid, color } from '@kis-technologies/kis-ui';
import { ActionOverlayProps } from './types';
import { selectors as configSelectors, Configuration } from 'services/configuration';
import { useSelector } from 'react-redux';
import { useStyles } from './styled';
import get from 'lodash.get';

/**
 * Overlay used for Actions
 */

export const ActionOverlay = (props: ActionOverlayProps) => {
  const { title, description = '', confirmText, onConfirm, cancelText, onCancel, height, width, flow } = props;
  const config = useSelector(configSelectors.selectConfiguration) as Configuration;
  const palette = get(config, 'configuration.globalSettings.palette');

  const classes = useStyles({ width, height, flow, palette })();

  const onEl = (el: HTMLElement) => {
    const defaults = {
      background: '#EFEFEF',
      zIndex: '500'
    };

    Object.assign(el.style, defaults, props.style);
  };

  const cancelButton = () => {
    if (cancelText) {
      return (
        <Button
          customSize="x-large"
          onClick={onCancel}
          appearance={flow === 'fair' ? 'secondary' : 'white'}
          className={classes.cancelButton}
          customColor={(flow === 'fair' && palette?.secondaryText) || color.BLACK}
        >
          {cancelText}
        </Button>
      );
    }
    return false;
  };

  const confirmButton = () => {
    if (confirmText) {
      return (
        <Button
          customSize="x-large"
          onClick={onConfirm}
          appearance="primary"
          className={classes.confirmButton}
          customColor={(flow === 'fair' && palette?.secondaryText) || undefined}
          disabled={!!!onConfirm}
        >
          {confirmText}
        </Button>
      );
    }
    return false;
  };

  return (
    <Backdrop onEl={onEl} sx={props.style} open>
      <Grid container className={classes.overlayContainer}>
        {/* Title */}
        <Box flexOverride="none" margin="0 15">
          {typeof title === 'string' ? (
            <Typography variant="h2" align="center" sx={{ lineHeight: 1 }}>
              {title}
            </Typography>
          ) : (
            title
          )}
        </Box>
        {/* Description */}
        <Box flexOverride="none" margin="5 10 7">
          {typeof description === 'string' ? (
            <Typography sx={{ lineHeight: 1 }} fontSize={30} align="center">
              {description}
            </Typography>
          ) : (
            description
          )}
        </Box>

        {/* Cancel and Confirm Buttons */}
        <AbsoluteBox bottom="-45px">
          <Stack spacing={12}>
            {cancelButton()}
            {confirmButton()}
          </Stack>
        </AbsoluteBox>
      </Grid>
    </Backdrop>
  );
};
